import React from "react";

interface CardGradientProps {
  className?: string;
  width?: string | number;
  height?: string | number;
}

const InvestNowButton: React.FC<CardGradientProps> = ({
  className,
  width = "20",
  height = "20",
}) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="8"
        stroke="#CFB2FF"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7 10H13"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.0049 7.00488L10.0049 13.0049"
        stroke="#FFA686"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default InvestNowButton;
